import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me').then(r => { setUser(r.data); setLoading(false); })
        .catch(() => { localStorage.removeItem('token'); setLoading(false); });
    } else setLoading(false);
  }, []);

  // Step 1: verify password, returns {requires2FA, userId, email} or logs in directly
  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    if (r.data.requires2FA) {
      return r.data; // caller handles showing 2FA screen
    }
    localStorage.setItem('token', r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  // Step 2: verify 2FA code
  const verify2FA = async (userId, code) => {
    const r = await api.post('/auth/verify-2fa', { userId, code });
    localStorage.setItem('token', r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => { localStorage.removeItem('token'); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, login, verify2FA, logout, loading, isAdmin: user?.role === 'admin', isDeptHead: user?.role === 'department_head' }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
